import React, { Component } from "react";
import { Link } from "react-router";
import ReactDOM from "react-dom";
import { browserHistory } from "react-router";

class MobileNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: window.innerWidth,
      mobileNavVisible: false
    };
  }
  handleResize = () => {
    this.setState({ windowWidth: window.innerWidth });
    if (window.innerWidth <= 738 && this.props.params.painting) {
      browserHistory.goBack();
    }
  };
  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("click", this.handleClickOutside.bind(this), true);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener(
      "click",
      this.handleClickOutside.bind(this),
      true
    );
  }
  navigationLinksMobile() {
    return (
      <ul>
        <li>
          <Link
            to="/art"
            activeClassName="active"
            className="link"
            onClick={this.handleNavClick.bind(this)}
          >
            ART
          </Link>
        </li>
        <li>
          <Link
            to="/news"
            activeClassName="active"
            className="link"
            onClick={this.handleNavClick.bind(this)}
          >
            NEWS
          </Link>
        </li>
        <li>
          <Link
            to="/story"
            activeClassName="active"
            className="link"
            onClick={this.handleNavClick.bind(this)}
          >
            STORY
          </Link>
        </li>
        <li>
          <Link
            to="/contact"
            activeClassName="active"
            className="link"
            onClick={this.handleNavClick.bind(this)}
          >
            CONTACT
          </Link>
        </li>
      </ul>
    );
  }
  handleClickOutside(event) {
    const domNode = ReactDOM.findDOMNode(this);
    if (!domNode || !domNode.contains(event.target)) {
      this.setState({
        mobileNavVisible: false
      });
    }
  }
  navigationLinksDesktop() {
    return (
      <ul>
        <li>
          <Link to="/">
            <h2>
              SILVER<br />KOPPEL
            </h2>
          </Link>
        </li>
        <li>
          <Link
            to="/art"
            activeClassName="active"
            className="link"
            title="Art"
            onClick={this.handleNavClick.bind(this)}
          >
            ART
          </Link>
        </li>
        <li>
          <Link
            to="/news"
            activeClassName="active"
            className="link"
            title="News"
            onClick={this.handleNavClick.bind(this)}
          >
            NEWS
          </Link>
        </li>
        <li>
          <Link
            to="/story"
            activeClassName="active"
            className="link"
            title="Story"
            onClick={this.handleNavClick.bind(this)}
          >
            STORY
          </Link>
        </li>
        <li>
          <Link
            to="/contact"
            activeClassName="active"
            className="link"
            title="Contact"
            onClick={this.handleNavClick.bind(this)}
          >
            CONTACT
          </Link>
        </li>
      </ul>
    );
  }
  renderMobileNav() {
    if (this.state.mobileNavVisible) {
      return this.navigationLinksMobile();
    }
  }

  handleNavClick(props) {
    if (!this.state.mobileNavVisible) {
      this.setState({ mobileNavVisible: true });
    } else {
      this.setState({ mobileNavVisible: false });
    }
  }
  renderNavigation() {
    if (this.state.windowWidth <= 1080) {
      return (
        <div className="navbar-mobile">
          <i
            className={
              (this.props.params.art || this.props.params.news) &&
              this.state.windowWidth <= 1080
                ? "fa fa-chevron-left"
                : ""
            }
            style={{ padding: "20px", marginBottom: "0", float: "left" }}
            aria-hidden="true"
            onClick={this.props.onClick}
          />
          <i
            className="fa fa-bars"
            style={{ padding: "20px", marginBottom: "0" }}
            aria-hidden="true"
            onClick={this.handleNavClick.bind(this)}
          />
          <div className="navbar-exhibition-title">
            <p>
              {this.props.params.art ? this.props.params.art : ""}
            </p>
          </div>
          <div style={{ clear: "both" }} />
          {this.renderMobileNav()}
        </div>
      );
    } else {
      return (
        <div className="navbar-desktop">
          {this.navigationLinksDesktop()}
        </div>
      );
    }
  }

  render() {
    return (
      <div id="nav">
        {this.renderNavigation()}
      </div>
    );
  }
}

export default MobileNav;



// WEBPACK FOOTER //
// ./src/components/Navbar.js